import { encodeFunctionData } from 'viem';
import { getRegistryModules } from '../../common/queries/index.js';
import { abi } from './abi.js';
import { GLOBAL_CONSTANTS } from '../../constants.js';
export const fetchRegistryModules = ({ client }) => getRegistryModules({ client });
export const getTrustAttestersAction = ({ attesters, threshold, }) => {
    const data = encodeFunctionData({
        functionName: 'trustAttesters',
        abi,
        args: [threshold, attesters],
    });
    return {
        to: GLOBAL_CONSTANTS.REGISTRY_ADDRESS,
        target: GLOBAL_CONSTANTS.REGISTRY_ADDRESS,
        value: BigInt(0),
        callData: data,
        data,
    };
};
export const findTrustedAttesters = async ({ client, accountAddress, }) => {
    return (await client.readContract({
        address: GLOBAL_CONSTANTS.REGISTRY_ADDRESS,
        abi,
        functionName: 'findTrustedAttesters',
        args: [accountAddress],
    }));
};
//# sourceMappingURL=usage.js.map